import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi } from '../axios';

export const useSendOtp = () => useMutation({
  mutationFn: (phone) => authApi.post('/v1/auth/send-otp', { phone }).then((r) => r.data),
});

export const useVerifyOtp = () => useMutation({
  mutationFn: (payload) => authApi.post('/v1/auth/verify-otp', payload).then((r) => r.data),
});

export const useLogout = () => useMutation({
  mutationFn: () => authApi.post('/v1/auth/logout').then((r) => r.data),
});

export const useUpdateUserProfile = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => authApi.patch('/v1/auth/profile', payload).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'profile'] }),
  });
};

export const useTeamUsers = () => useQuery({
  queryKey: ['auth', 'users'],
  queryFn: () => authApi.get('/v1/auth/users').then((r) => r.data),
  staleTime: 60000,
});

export const useInviteUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => authApi.post('/v1/auth/invite', payload).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'users'] }),
  });
};
